<template>
	<a-layout-sider :width="'auto'">
		<transition-group
			name="air__menuFlyout__animation"
			:duration="1"
		>
			<template v-for="(item, index) in renderedFlyoutItems">
				<div
					:key="index"
					:style="{
						left: `${item.itemDimensions.left + item.itemDimensions.width - 10}px`,
						top: `${item.itemDimensions.top}px`
					}"
					:class="{
						[$style.air__menuFlyout]: true,
						[$style.air__menuFlyoutLeft]: $settings.menuLayoutType === 'left',
						[$style.air__menuFlyout__black]: $settings.flyoutMenuColor === 'dark',
						[$style.air__menuFlyout__white]: $settings.flyoutMenuColor === 'white',
						[$style.air__menuFlyout__gray]: $settings.flyoutMenuColor === 'gray'
					}"
				>
					<ul
						:class="$style.air__menuLeft__list"
						@mouseenter="handleFlyoutContainerOver(item.key)"
						@mouseleave="handleFlyoutOut(item.key)"
					>
						<template v-for="(sitem, sindex) in item.items">
							<item
								:key="sindex"
								:item="sitem"
								:styles="$style"
								:active-item="activeItem"
							/>
						</template>
					</ul>
				</div>
			</template>
		</transition-group>
		<div
			:class="{
				[$style.air__menuLeft]: true,
				[$style.air__menuLeft__mobileToggled]: $settings.isMobileMenuOpen,
				[$style.air__menuLeft__toggled]: $settings.isMenuCollapsed,
				[$style.air__menuLeft__unfixed]: $settings.isMenuUnfixed,
				[$style.air__menuLeft__shadow]: $settings.isMenuShadow,
				[$style.air__menuLeft__flyout]: $settings.menuType === 'flyout',
				[$style.air__menuLeft__compact]: $settings.menuType === 'compact',
				[$style.air__menuLeft__blue]: $settings.menuColor === 'blue',
				[$style.air__menuLeft__white]: $settings.menuColor === 'white',
				[$style.air__menuLeft__gray]: $settings.menuColor === 'gray',
				// eslint-disable-next-line max-len
				[$style.air__menuFlyout__black]: $settings.flyoutMenuColor === 'dark' && $settings.menuType !== 'default',
				// eslint-disable-next-line max-len
				[$style.air__menuFlyout__white]: $settings.flyoutMenuColor === 'white' && $settings.menuType !== 'default',
				// eslint-disable-next-line max-len
				[$style.air__menuFlyout__gray]: $settings.flyoutMenuColor === 'gray' && $settings.menuType !== 'default'
			}"
		>
			<div :class="$style.air__menuLeft__outer">
				<a
					href="javascript: void(0);"
					:class="$style.air__menuLeft__mobileToggleButton"
					@click="toggleMobileMenu"
				>
					<span />
				</a>
				<a
					href="javascript: void(0);"
					:class="$style.air__menuLeft__toggleButton"
					@click="toggleMenu"
				>
					<span />
					<span />
				</a>
				<a
					href="javascript: void(0);"
					:class="$style.air__menuLeft__logo"
				>
					<g-logo
						:dark="true"
						:text="$settings.menuType === 'compact' ? false : true"
					/>
				</a>
				<a :class="$style.air__menuLeft__user">
					<div :class="$style.air__menuLeft__user__avatar">
						<g-avatar
							:user="$gestios.profile"
							:tooltip="false"
							:size="40"
							:color="$colors['gray-6']"
						/>
					</div>

					<div :class="$style.air__menuLeft__user__name">{{ $gestios.profile.Nick }}</div>
					<div :class="$style.air__menuLeft__user__role">{{ $gestios.profile.Group.Name }}</div>
				</a>
				<vue-custom-scrollbar :class="[$style.scrollbar, $style[$settings.env]]">
					<div :class="$style.air__menuLeft__container">
						<ul :class="$style.air__menuLeft__list">
							<template v-for="(item, index) in menu">
								<item
									v-if="!item.children
										&& !item.category
										&& $store.getters['auth/section'](item)
									"
									:key="index"
									:item="item"
									:styles="$style"
									:active-item="activeItem"
									:tooltip="flyoutActive"
								/>
								<sub-menu
									v-if="item.children && $store.getters['auth/section'](item)"
									:key="index"
									:item="item"
									:styles="$style"
									:active-item="activeItem"
									:active-submenu="activeSubmenu"
									:handle-submenu-click="handleSubmenuClick"
									:handle-flyout-over="handleFlyoutOver"
									:handle-flyout-out="handleFlyoutOut"
								/>
								<category
									v-if="item.category && $store.getters['auth/section'](item)"
									:key="index"
									:item="item"
									:styles="$style"
								/>
							</template>
						</ul>
					</div>

					<div class="mt-auto">
						<ul :class="$style.air__menuLeft__list">
							<li :class="[$style.air__menuLeft__category]">
								<span>Otros</span>
							</li>

							<li v-if="$settings.custom && $settings.custom.config">
								<div
									:class="{
										[$style.air__menuLeft__item]: true,
										[$style.air__menuLeft__item__active]: $route.name === $settings.custom.config
									}"
								>
									<router-link
										:to="{name: $settings.custom.config}"
										:class="$style.air__menuLeft__link"
									>
										<b :class="$style.air__menuLeft__icon">🔧</b>
										<span> Configuración</span>
									</router-link>
								</div>
							</li>
							<li>
								<div :class="$style.air__menuLeft__item">
									<a
										:class="$style.air__menuLeft__link"
										@click="$hub.$emit('_toggleSettings')"
									>
										<b :class="$style.air__menuLeft__icon">🎁</b>
										<span> Personalizar</span>
									</a>
								</div>
							</li>
						</ul>
					</div>
				</vue-custom-scrollbar>
			</div>
		</div>
		<a
			href="javascript: void(0);"
			:class="$style.air__menuLeft__backdrop"
			@click="toggleMobileMenu"
		/>
	</a-layout-sider>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
import _ from 'lodash';
import SubMenu from './partials/submenu';
import Item from './partials/item';
import Category from './partials/category';

export default {
	name: 'MenuLeft',
	components: {
		vueCustomScrollbar,
		SubMenu,
		Item,
		Category
	},
	data() {
		return {
			activeSubmenu: '',
			activeItem: '',
			renderedFlyoutItems: {},
			flyoutTimers: {}
		};
	},
	computed: {
		menu() {
			return this.$settings.menu;
		},
		flyoutActive() {
			return (this.$settings.menuType === 'flyout' || this.$settings.menuType === 'compact' || this.$settings.isMenuCollapsed) && !this.$settings.isMobileView;
		}
	},
	watch: {
		$route() {
			this.setActiveItems();
		}
	},
	mounted() {
		this.setActiveItems();
	},
	methods: {
		toggleMobileMenu() {
			const setting = 'isMobileMenuOpen';
			const value = !this.$settings[setting];
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
		toggleMenu() {
			const setting = 'isMenuCollapsed';
			const value = !this.$settings[setting];
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
		handleSubmenuClick(key) {
			const currentKey = this.activeSubmenu;
			if (this.flyoutActive) {
				return;
			}
			this.activeSubmenu = currentKey === key ? '' : key;
		},
		setActiveItems() {
			const menuData = this.menu;

			const params = { name: this.$route.name };
			if (this.$route.params.length > 0) params.params = this.$route.params;

			const flattenItems = (items, key) => items.reduce((flattenedItems, item) => {
				flattenedItems.push(item);
				if (Array.isArray(item[key])) {
					return flattenedItems.concat(flattenItems(item[key], key));
				}
				return flattenedItems;
			}, []);

			const activeItem = _.find(flattenItems(menuData, 'children'), ['url', params]);

			const activeSubmenu = menuData.reduce((key, parent) => {
				if (Array.isArray(parent.children)) {
					parent.children.map((child) => {
						if (activeItem && child.key === activeItem.key) {
							key = parent;
						}
						return '';
					});
				}
				return key;
			});

			if (activeItem) this.activeItem = activeItem.key;
			this.activeSubmenu = activeSubmenu.key;
		},
		handleFlyoutOver(event, key, items) {
			if (this.flyoutActive) {
				clearInterval(this.flyoutTimers[key]);
				const item = event.currentTarget;

				const itemDimensions = item.getBoundingClientRect();
				this.renderedFlyoutItems = {
					...this.renderedFlyoutItems,
					[key]: {
						key,
						itemDimensions,
						items
					}
				};
			}
		},
		handleFlyoutOut(key) {
			if (this.flyoutActive) {
				this.flyoutTimers[key] = setTimeout(() => {
					const updatedFlyoutItems = { ...this.renderedFlyoutItems };
					delete updatedFlyoutItems[key];
					this.renderedFlyoutItems = {
						...updatedFlyoutItems
					};
				}, 100);
			}
		},
		handleFlyoutContainerOver(key) {
			clearInterval(this.flyoutTimers[key]);
		}
	}
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
